import { MailCheck } from "lucide-react";

import { formatDate } from "../formatters";

const EMAIL_TYPE_LABELS = {
  ticket_created: "Confirmation de création du ticket",
  status_changed: "Mise à jour du statut",
  support_reply: "Nouvelle réponse du support",
};

export default function TicketEmailHistory({ entries = [] }) {
  return (
    <div className="support-ticket-panel">
      <div className="support-email-history-heading">
        <MailCheck aria-hidden="true" />
        <div>
          <h3 className="heading-3">Emails envoyés au client</h3>
          <p className="body-small">
            Ce journal contient uniquement les envois confirmés comme réussis.
          </p>
        </div>
      </div>

      {entries.length === 0 ? (
        <p className="body-small">Aucun email confirmé pour ce ticket.</p>
      ) : (
        entries
          .slice()
          .reverse()
          .map((entry) => (
            <div key={entry.id} className="support-email-history-item">
              <div>
                <strong>
                  {EMAIL_TYPE_LABELS[entry.email_type] || entry.subject}
                </strong>
                <p>{entry.recipient}</p>
              </div>
              <small>{formatDate(entry.sent_at)}</small>
            </div>
          ))
      )}
    </div>
  );
}
